<!--suppress XmlInvalidId, HtmlUnknownBooleanAttribute, TypeScriptUnresolvedVariable, AngularUndefinedBinding -->

<div class="row mt-2">
  <div class="col-10">
    <nav class="breadcrumb-one" aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="javascript:void(0);">
          <svg class="feather feather-home" fill="none" height="24" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
            <polyline points="9 22 9 12 15 12 15 22"></polyline>
          </svg>
        </a></li>
        <li class="breadcrumb-item active" aria-current="page" translate><a href="/private/settings" translate>Settings</a></li>
        <li class="breadcrumb-item active" aria-current="page" translate>Account Management</li>
        <li class="breadcrumb-item">
          <a href="https://www.youtube.com/watch?v=w4PetgN78-8" target="_blank">
            <svg width="15" height="15" viewBox="0 0 800 800" xmlns="http://www.w3.org/2000/svg">
              <g id="Group">
                <path id="Path" fill="#06209f" stroke="none"
                      d="M 683.015686 117.331543 C 526.902344 -38.973694 273.638733 -39.129089 117.331566 116.982361 C -38.973663 273.097717 -39.130989 526.363159 116.984306 682.670349 C 273.095764 838.975586 526.36322 839.130981 682.670349 683.017639 C 838.973694 526.906128 839.130981 273.636841 683.015686 117.331543 Z M 455.850311 653.819031 C 455.850311 659.991028 450.848602 664.988892 444.68042 664.988892 L 355.321472 664.988892 C 349.15332 664.988892 344.151642 659.991028 344.151642 653.819031 L 344.151642 322.097748 C 344.151642 315.925751 349.15332 310.927887 355.321472 310.927887 L 444.68042 310.927887 C 450.848602 310.927887 455.850311 315.923828 455.850311 322.097748 L 455.850311 653.819031 Z M 400.000977 264.571594 C 364.281158 264.571594 335.218811 235.513062 335.218811 199.791382 C 335.218811 164.073486 364.279266 135.009216 400.000977 135.009216 C 435.722656 135.009216 464.783112 164.071594 464.783112 199.791382 C 464.783112 235.513062 435.718811 264.571594 400.000977 264.571594 Z"/>
              </g>
              <g id="g1"/>
            </svg>
          </a>
        </li>
      </ol>
    </nav>
  </div>
  <div class="col-2">
    <button *ngIf="!submitting && (isMerchant || isManager)" class="btn btn-primary" translate (click)="submitForm()">Save Changes</button>
  </div>
</div>
<div [hidden]="loading" *ngIf="myBusiness" class="account-settings-container layout-top-spacing">
  <div class="account-content">
    <div class="scrollspy-example" data-spy="scroll" data-target="#account-settings-scroll" data-offset="-100">
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 layout-spacing">
          <form id="general-info" [formGroup]="form" class="section general-info">
            <div class="info">
              <h6 class="" translate>Account Settings</h6>
              <div class="row">
                <div class="col-lg-11 mx-auto">
                  <div class="row">
                    <div class="col-xl-2 col-lg-12 col-md-4">
                      <div class="upload mt-4 pr-md-4 d-flex flex-column">
                        <input [hidden]="!isMerchant && !isManager" type="file" (change)="handleMerchantImageInput($event.target.files)" id="merchant-logo" [ngClass]="{'dropify' : (myBusiness.subAccountGovId == null || myBusiness.subAccountType == 'Manager')}" data-max-file-size="2M"/>
                        <p class="mt-2 text-center"><i class="flaticon-cloud-upload mr-1"></i> {{'Merchant Logo' | translate}}</p>
                      </div>
                    </div>
                    <div class="col-xl-10 col-lg-12 col-md-8 mt-md-0 mt-4">
                      <div class="form">
                        <!---->
                        <div class="row">
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label for="firstName" translate>First Name</label>
                              <input [readOnly]="!isMerchant && !isManager" [ngClass]="{'is-invalid': this.form.controls.firstName.errors && submitted}" type="text" formControlName="firstName" class="form-control mb-1" id="firstName" placeholder="{{'First Name' | translate}}">
                              <span class="invalid-feedback" *ngIf="submitted && this.form.controls.firstName.errors && this.form.controls.firstName.errors.required">This field is required</span>
                              <span class="invalid-feedback" *ngIf="submitted && this.form.controls.firstName.errors && this.form.controls.firstName.errors.pattern">This field has invalid value</span>
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label for="lastName" translate>Last Name</label>
                              <input [readOnly]="!isMerchant && !isManager" [ngClass]="{'is-invalid': this.form.controls.lastName.errors && submitted}" type="text" formControlName="lastName" class="form-control mb-1" id="lastName" placeholder="{{'Last Name' | translate}}">
                              <span class="invalid-feedback" *ngIf="submitted && this.form.controls.lastName.errors && this.form.controls.lastName.errors.required">This field is required</span>
                              <span class="invalid-feedback" *ngIf="submitted && this.form.controls.lastName.errors && this.form.controls.lastName.errors.pattern">This field has invalid value</span>
                            </div>
                          </div>
                        </div>
                        <!---->
                        <div class="row" *ngIf="myBusiness.licenseType != 'marketer'">
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label for="shopName" translate>Shop Name</label>
                              <input [readOnly]="!isMerchant && !isManager" [ngClass]="{'is-invalid': this.form.controls.shopName.errors && submitted}" type="text" formControlName="shopName" class="form-control mb-1" id="shopName" placeholder="{{'Shop Name' | translate}}">
                              <span class="invalid-feedback" *ngIf="submitted && this.form.controls.shopName.errors && this.form.controls.shopName.errors.required">This field is required</span>
                              <span class="invalid-feedback" *ngIf="submitted && this.form.controls.shopName.errors && this.form.controls.shopName.errors.pattern">This field has invalid value</span>
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label for="vat" translate>VAT Number</label>
                              <input [readOnly]="!isMerchant && !isManager" [ngClass]="{'is-invalid': this.form.controls.vat.errors && submitted}" type="text" formControlName="vat" class="form-control mb-1" id="vat" placeholder="{{'Enter if you have VAT number' | translate}}">
                              <span class="invalid-feedback" *ngIf="submitted && this.form.controls.vat.errors && this.form.controls.vat.errors.required">This field is required</span>
                              <span class="invalid-feedback" *ngIf="submitted && this.form.controls.vat.errors && this.form.controls.vat.errors.pattern">This field has invalid value</span>
                            </div>
                          </div>
                        </div>
                        <div class="row" *ngIf="myBusiness.licenseType != 'marketer'">
                          <div class="col-sm-6">
                            <label for="storeUsername" translate>Store Username</label>
                            <div class="input-group">
                              <input [readOnly]="!isMerchant && !isManager" type="text" (change)="storeUsernameChanged()" formControlName="storeUsername" class="form-control" id="storeUsername" placeholder="{{'Store Username' | translate}}" aria-describedby="inputGroupPrepend">
                              <div class="input-group-append">
                                <span class="input-group-text" id="inputGroupPrepend">
                                  <span *ngIf="storeUsernameValidating == 'pending'" class="spinner-grow spinner-grow-sm text-info align-self-center"></span>
                                  <svg *ngIf="storeUsernameValidating == 'valid'" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check text-success"><polyline points="20 6 9 17 4 12"></polyline></svg>
                                  <svg *ngIf="storeUsernameValidating == 'invalid'" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-alert-octagon text-danger-80">
                                    <polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon><line x1="12" y1="8" x2="12" y2="12"></line>
                                    <line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label for="vat" translate>Store URL</label>
                              <input readonly type="text" formControlName="storeUrl" class="form-control mb-1"/>
                            </div>
                          </div>

                        </div>
                        <!---->
                        <div class="form-group">
                          <label for="email" translate>E-Mail</label>
                          <input type="text" formControlName="email" class="form-control mb-1" id="email" placeholder="{{'E-Mail' | translate}}">
                        </div>
                        <!---->
                        <div class="row">
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label for="licenseType" translate>License Type</label>
                              <input type="text" formControlName="licenseType" class="form-control mb-1" id="licenseType" placeholder="{{'License Type' | translate}}">
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label for="licenseNumber" translate>License Number</label>
                              <input type="text" formControlName="licenseNumber" class="form-control mb-1" id="licenseNumber" placeholder="{{'License Number' | translate}}">
                            </div>
                          </div>
                        </div>
                        <!---->
                        <div class="row">
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label for="licenseName" translate>License Name</label>
                              <input type="text" formControlName="licenseName" class="form-control mb-1" id="licenseName" placeholder="{{'License Name' | translate}}">
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <label for="mobile" translate>Mobile</label>
                            <div class="input-group">
                              <input type="text" formControlName="mobile" class="form-control" id="mobile" placeholder="{{'Mobile' | translate}}" aria-describedby="inputGroupPrepend" required>
                              <div class="invalid-feedback" translate>
                                Mobile
                              </div>
                              <div class="input-group-append" *ngIf="isManager || isMerchant">
                                <span class="input-group-text">
                                  <a href="javascript:void(0);" data-toggle="modal" [attr.data-target]="'#mobileModal'">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-edit">
                                      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                                      <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                                    </svg>
                                  </a>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!---->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="myBusiness.affiliateUrl && (isMerchant || isManager)" class="affiliateUrl">
    <div class="scrollspy-example" data-spy="scroll" data-target="#account-settings-scroll" data-offset="-100">
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 layout-spacing">
          <form id="affiliateUrl-info" [formGroup]="affiliateUrlForm" class="section general-info">
            <div class="info">
              <h6 translate>Affiliate</h6>
              <div class="row">
                <div class="col-lg-11 mx-auto">
                  <div class="row">
                    <div class="col-xl-12 col-lg-12 col-md-12 mt-md-0 mt-4">
                      <div class="form">
                        <!---->
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label for="affiliateUrl" translate>URL</label>
                              <input id="affiliateUrl" readonly formControlName="affiliateUrl" [contentEditable]="false" type="text" class="form-control mb-1" placeholder="{{'Affiliate URL' | translate}}">
                            </div>
                          </div>
                        </div>
                        <!---->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <div [hidden]="partnerConnectionsRequest == null || partnerConnectionsRequest.length == 0" class="partner-request-content bg-white">
    <div class="scrollspy-example" data-spy="scroll" data-target="#partner-requests-scroll" data-offset="-100">
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 layout-spacing">
          <form id="partner-requests-info" [formGroup]="form" class="section general-info">
            <div class="info">
              <h6 translate>Partner connections profiles</h6>
              <div class="row">
                <div class="col-lg-11 mx-auto">
                  <div class="table-responsive mb-4 mt-4">
                    <table id="partner-requests-extension" class="table table-hover non-hover" style="width:100%">
                      <thead>
                      <tr>
                        <th translate>Profile No</th>
                        <th translate>Profile Reference No</th>
                        <th translate>Partner License Name</th>
                        <th translate>Profile Status</th>
                        <th translate>...</th>
                      </tr>
                      </thead>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- Account settings footer -->

  <button *ngIf="!submitting && (isMerchant || isManager)" class="btn btn-primary" translate (click)="submitForm()">Save Changes</button>
  <div *ngIf="submitting" class="account-settings-footer">
    <div class="as-footer-container">
      <div *ngIf="submitting" class="mx-auto spinner-grow text-info loader-lg"></div>
    </div>
  </div>

</div>
<div *ngIf="loading">
  <div class="d-flex">
    <div class="mx-auto spinner-grow text-info align-self-center loader-lg"></div>
  </div>
</div>
